export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN';
export const UPDATE_FEATURES = 'UPDATE_FEATURES';
export const UPDATE_LOCAL_PREFS = 'UPDATE_LOCAL_PREFS';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const CLEAR_USER_ERRORS = 'CLEAR_USER_ERRORS';
export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR';
